import { render } from "./StatsArea.vue?vue&type=template&id=47661de0"
import script from "./StatsArea.vue?vue&type=script&lang=js"
export * from "./StatsArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__